import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import { FaArrowRight, FaFilePdf } from "react-icons/fa";

const OfferDocuments = () => {
  const pageTitle = "Offer Documents";
  const docs = [
    {
      year: "2024",
      date: "17 November, 2025",
      url: "/assets/pdf/DPRH/DRHP_BLACK OPAL CONSULTANTS LIMITED.pdf",
      image: "/assets/img/Report_1.png",
      name: "DRHP_BLACK OPAL CONSULTANTS LIMITED"
    },
    {
      year: "2024",
      date: "31 July, 2026",
      url: "/assets/pdf/Addendum_DRHP/Black Opal Addendum.pdf",
      image: "/assets/img/Report_1.png",
      name: "Black Opal Addendum"
    },
    {
      year: "2024",
      date: "23 September, 2026",
      url: "/assets/pdf/Offer_Documents/RHP_Black Opal Consultants Limited.pdf",
      image: "/assets/img/Report_1.png",
      name: "RHP_Black Opal Consultants Limited"
    },
    {
      year: "2024",
      date: "23 September, 2026",
      url: "/assets/pdf/Offer_Documents/Abridged Prospectus_Black Opal Consultants Limited.pdf",
      image: "/assets/img/Report_1.png",
      name: "Abridged Prospectus_Black Opal Consultants Limited"
    },
    {
      year: "2026",
      date: "6 October, 2026",
      url: "/assets/pdf/Offer_Documents/Prospectus_Black Opal Consultants Limited.pdf",
      image: "/assets/img/Report_2.png",
      name: "Prospectus_Black Opal Consultants Limited"
    }
  ];

  const renderDocs = (docsList) => (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mt-2 mb-5 px-5">
      {docsList.map((doc, index) => (
        <div
          key={index}
          className="offer-doc-card bg-white border-1 border-[#989898] rounded-lg shadow-sm overflow-hidden cursor-pointer hover:shadow-md transition flex flex-col"
          onClick={() => window.open(encodeURI(doc.url), "_blank")}
        >
          {/* Top Thumbnail */}
          <div className="!h-36 w-full border-b border-[#989898] bore !overflow-hidden bg-gray-100">
            <img
              src={doc.image}
              alt={`Report ${doc.year}`}
              className="!w-full !h-full !object-fill"
            />
          </div>

          {/* Bottom Content  */}
          <div className="px-3 py-3 bg-white">
            <div className="!flex !items-start !justify-between !gap-2">
              <div className="!flex !gap-2 items-start min-w-0 flex-1">
                <FaFilePdf className="!text-red-600 !text-lg shrink-0 mt-0.5" />
                <div className="min-w-0">
                  <p className="!m-0 !p-0 !font-medium !text-sm !leading-snug !text-left" style={{ textAlign: "left" }}>
                    {doc.name}
                  </p>
                  <p className="!m-0 !mt-1 !p-0 !text-gray-500 !text-xs !leading-normal !text-left" style={{ textAlign: "left" }}>{doc.date}</p>
                </div>
              </div>
              <div className="bg-gray-200 p-1 rounded-full shrink-0">
                <FaArrowRight className="text-[#F26624] text-sm" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>

      <style>{`.offer-doc-card p { text-align: left !important; }`}</style>
      <div className="main-content">
        <Header />
        {/* Banner Section */}
        <div
          className="relative w-full h-64 md:h-80 lg:h-96"
          style={{
            backgroundImage: `url(/assets/img/Financial_banner.png)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "100%",
          }}
        >
        </div>

        {/* Page Content */}
        <div className="flex flex-col py-2 overflow-hidden -mt-2">
          {/* Top Section: Full-width Background Image with Text on Left */}
          <h2 className="text-2xl !font-semibold mt-5 px-5 !text-[#F26624]">
            Offer Documents
          </h2>

          {renderDocs(docs)}
        </div>

        <Footer />
      </div>
    </>
  );
};

export default OfferDocuments;
